var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFieldWrapper',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var vuelidateIns = ref.vuelidateIns;
var value = ref.value;
var listeners = ref.listeners;
var attrs = ref.attrs;
return [_c('span',[(_vm.mounted)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cypressTestInput),expression:"cypressTestInput"}],staticStyle:{"display":"none"},attrs:{"id":attrs.id},domProps:{"value":(_vm.cypressTestInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cypressTestInput=$event.target.value}}}):_vm._e(),_c('editor',{class:vuelidateIns && 'border-danger',attrs:{"value":value,"api-key":"c21xora5cqvlh2qa9snoh4syuep4gwac8piuek5ozs52u839","init":{
        height: _vm.height,
        toolbar:
          'undo redo | formatselect | bold italic backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help'
      }},on:{"input":listeners.input}})],1)]}}])},'BaseFieldWrapper',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }